import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppContext } from 'app/app-config';

export type LegacyPackageResponse = LegacyPackage[];

export interface LegacyPackage {
  title: string;
  tagline: string;
  percentage_choose: string;
  coverage_attributes: LegacyCoverageAttribute[];
  payment_options: LegacyPaymentOption[];
}

export interface LegacyCoverageAttribute {
  name: string;
  value: number | string;
  help_text: string;
}

export interface LegacyPaymentOption {
  payment_type: string;
  title: string;
  total_amount: string;
  payments: LegacyPayment[];
  wind_mit_applied: boolean;
}

export interface LegacyPayment {
  amount: string;
  due_date: string;
}

export interface LegacySelectedPackageInfo {
  discounts: {
    wind_mit_applied: boolean;
  };
  package: string;
  payment_schedule: string;
}

export interface LegacyPackageSelectionResponse {
  redirect_to: string;
}

@Injectable({
  providedIn: 'root',
})
export class LegacyPackagesService {
  @AppContext() private _appContext!: AppContext;

  private httpClient = inject(HttpClient);

  private get url() {
    return `${this._appContext.apiRoot.quoteV1}/packages`;
  }

  getPackages(): Observable<LegacyPackageResponse> {
    return this.httpClient.get<LegacyPackageResponse>(this.url);
  }

  selectPackage(selectedPackageInfo: LegacySelectedPackageInfo): Observable<LegacyPackageSelectionResponse> {
    return this.httpClient.post<LegacyPackageSelectionResponse>(this.url, selectedPackageInfo);
  }
}
